import axios from 'axios';
import { ENDPOINTS } from '../constants/endpoints';
import {
    ReserveShortfallResult, ShortfallRequisitionResult, StockReservation, StockReservationFilters,
    StockReservationPage,
} from '../interfaces/stockReservation.interface';
import { AuthService } from './auth.service';

export const StockReservationService = {
    /** Reservations of the institution (STOCK_RESERVATION_VIEW). */
    list: async (institutionId: string, filters: StockReservationFilters, page = 0, size = 10): Promise<StockReservationPage> => {
        const params: Record<string, string | number> = { page, size };
        (Object.keys(filters) as (keyof StockReservationFilters)[]).forEach((k) => {
            const v = filters[k];
            if (v) params[k] = v;
        });
        const r = await axios.get(ENDPOINTS.STOCK_RESERVATION.LIST_BY_INSTITUTION(institutionId),
            { headers: AuthService.getAuthHeader(), params });
        return r.data;
    },

    /** Give the held quantity back to free stock (STOCK_RESERVATION_MANAGE). */
    release: async (institutionId: string, id: string): Promise<StockReservation> =>
        (await axios.post(ENDPOINTS.STOCK_RESERVATION.RELEASE(institutionId, id), null,
            { headers: AuthService.getAuthHeader() })).data,

    /** Hold the part of the order's shortfall that free stock covers (STOCK_RESERVATION_MANAGE). */
    reserveShortfall: async (institutionId: string, buyerOrderId: string): Promise<ReserveShortfallResult> =>
        (await axios.post(ENDPOINTS.STOCK_RESERVATION.RESERVE_SHORTFALL(institutionId, buyerOrderId), null,
            { headers: AuthService.getAuthHeader() })).data,

    /** One requisition for the whole shortfall, rounded up (STOCK_RESERVATION_MANAGE). */
    raiseShortfallRequisition: async (institutionId: string, buyerOrderId: string): Promise<ShortfallRequisitionResult> =>
        (await axios.post(ENDPOINTS.STOCK_RESERVATION.RAISE_SHORTFALL_REQUISITION(institutionId, buyerOrderId), null,
            { headers: AuthService.getAuthHeader() })).data,
};
